import { FormEvent, useEffect, useState } from 'react';
import { FormControl, Button, Table, Label } from 'react-bootstrap';
import { IListItem, IPhoneNumberForEdit } from '@nkr/models/index';
import { PhoneType } from '@nkr/enums/phone-type';
import styled from 'styled-components';
import usePrevious from '@nkr/services/use-previous';

const TableWrapper = styled(Table)`
    & > tbody > tr > td {
        vertical-align: middle;
    }
`;

interface IProps {
    data: IPhoneNumberForEdit,
    showMobileProvider: boolean,
    phoneTypes: IListItem[],
    mobileProviders: IListItem[],
    onAdd: (type: number, phoneNumber: string, mobileProvider: number) => void,
    onUpdate: (id: number, type: number, phoneNumber: string, mobileProvider: number) => void,
    onCancelEdit: () => void
}

const PhoneNumberAddEdit = (props: IProps) => {
    const [id, setId] = useState(0);
    const [type, setType] = useState(0);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [mobileProvider, setMobileProvider] = useState(0);

    const previousData = usePrevious(props.data);

    useEffect(() => {
        if (previousData == null && props.data != null) {
            setId(props.data.id);
            setType(props.data.phoneTypeId);
            setPhoneNumber(props.data.number);
            setMobileProvider(props.data.mobileProviderId);
        }

        if (previousData != null && props.data == null) {
            setId(0);
            setType(0);
            setPhoneNumber('');
            setMobileProvider(0);
        }
    }, [props.data]);

    const handleTypeChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        setType(parseInt(e.currentTarget.value));
    };

    const handlePhoneNumberChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        setPhoneNumber(e.currentTarget.value);
    };

    const handleMobileProviderChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        setMobileProvider(parseInt(e.currentTarget.value));
    };

    const handleAdd = () => {
        props.onAdd(type, phoneNumber, mobileProvider);

        setId(0);
        setType(0);
        setPhoneNumber('');
        setMobileProvider(0);
    };

    const handleUpdate = () => {
        props.onUpdate(id, type, phoneNumber, mobileProvider);

        setId(0);
        setType(0);
        setPhoneNumber('');
        setMobileProvider(0);
    };

    const canAddUpdate = type > 0 && phoneNumber != '';

    return (
        <tr>
            <td>
                <FormControl
                    componentClass='select'
                    bsSize='small'
                    value={type}
                    onChange={handleTypeChange}
                >
                    <option value={0}>- Select -</option>
                    {props.phoneTypes.map((pt, index) =>
                        <option key={index} value={pt.id}>{pt.description}</option>
                    )}
                </FormControl>
            </td>

            <td>
                <FormControl
                    bsSize='small'
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                />
            </td>

            {props.showMobileProvider && (
                <td>
                    {type == PhoneType.Mobile ?
                        <FormControl
                            componentClass='select'
                            bsSize='small'
                            value={mobileProvider}
                            onChange={handleMobileProviderChange}
                        >
                            <option value={0}>- Select Provider -</option>
                            {props.mobileProviders.map((mp, index) =>
                                <option key={index} value={mp.id}>{mp.description}</option>
                            )}
                        </FormControl>
                        :
                        <Label style={{ fontSize: '90%' }}>{type == 0 ? 'PENDING TYPE' : 'N/A'}</Label>
                    }
                </td>
            )}

            <td style={{ textAlign: 'center' }}>
                {id == 0 ?
                    <Button bsStyle='primary' bsSize='xs' style={{ minWidth: 45 }} disabled={!canAddUpdate} onClick={handleAdd}>Add</Button>
                    :
                    <>
                        <Button bsStyle='primary' bsSize='xs' style={{ minWidth: 45, marginRight: 5 }} disabled={!canAddUpdate} onClick={handleUpdate}>Update</Button>
                        <Button bsSize='xs' style={{ minWidth: 45 }} onClick={props.onCancelEdit}>Cancel</Button>
                    </>
                }
            </td>
        </tr>
    );
}

export default PhoneNumberAddEdit;